import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CryptoJS from 'crypto-js';
import './Login3D.css';
import api from '../api';
import LuxuryCasinoLogin from './LuxuryCasinoLogin';

const API = process.env.REACT_APP_API;

async function login(username, password, apiVersion) {
  const baseUrl = API;

  if (!baseUrl) {
    throw new Error('API URL is not defined. Please check your environment variables.');
  }

  try {
      const data = await api.post(`${baseUrl}/admin/login`, {
        username,
        password
      });

      if (data.token) {
        const hashedApiVersion = CryptoJS.SHA256(apiVersion).toString();
        localStorage.setItem('token', data.token);
        localStorage.setItem('apiVersion', hashedApiVersion);
        localStorage.setItem('username', data.username);
        localStorage.setItem('useLocalCards', data.useLocalCards ? 'true' : 'false');
        if (data.adminId) {
          localStorage.setItem('adminId', data.adminId);
        }
        return data;
      } else {
        throw new Error('Unauthorized');
      }
    } catch (err) {
      console.error('Login error:', err);
      throw err;
    }
}

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [apiVersion, setApiVersion] = useState('1');
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const [isPower, setIsPower] = useState(false);
  const [showVersionChoice, setShowVersionChoice] = useState(false);
  const [is3DLogin, setIs3DLogin] = useState(false);
  const [isLuxuryLogin, setIsLuxuryLogin] = useState(false);

  useEffect(() => {
    const url = window.location.href.toLowerCase();
    setIsPower(url.includes('power'));
    setShowVersionChoice(url.includes('pbingo') || url.includes('phoenix') || url.includes('locanl'));
    setIs3DLogin(url.includes('locanl') || url.includes('phoenix'));
    setIsLuxuryLogin(url.includes('luxury') || url.includes('casino') || url.includes('premium'));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const data = await login(username, password, apiVersion);
      if (data.adminId) {
        localStorage.setItem('adminId', data.adminId);
      }
      // Add success toast with luxury styling
      toast.success('Welcome to the Royal Palace! 👑', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: 'luxury-toast-success'
      });
      
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 1000);
    } catch (err) {
      toast.error(`Access Denied: ${err.message} 🚫`, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: 'luxury-toast-error'
      });
      console.error('Login error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
      <div className="luxury-casino-wrapper">
        <LuxuryCasinoLogin
          onSubmit={handleSubmit}
          username={username}
          setUsername={setUsername}
          password={password}
          setPassword={setPassword}
          apiVersion={apiVersion}
          setApiVersion={setApiVersion}
          isLoading={isLoading}
          showVersionChoice={showVersionChoice}
        />
        <ToastContainer 
          position="top-center"
          theme="dark"
          toastClassName="luxury-toast"
        />
      </div>
    );
}

export default Login;
